import React from "react";
import usePageMeta from "../hooks/usePageMeta";
import Hero from "../components/Hero";
import TechPartnerships from "../components/TechPartnerships";
import Services from "../components/Services";
import AIDataServices from "../components/AIDataServices";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Skills from "../components/Skills";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";

const Home = () => {
  usePageMeta();

  return (
    <>
      <Hero />
      <TechPartnerships />
      <Services />
      <AIDataServices />
      <Portfolio />
      <About />
      <Skills />
      <Testimonials />
      <Contact />
    </>
  );
};

export default Home;
